import React, { PureComponent } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getSentimentColor, numberWithCommas } from "../utils";
import { Popup } from "semantic-ui-react";
import HighchartsCustomEvents from "highcharts-custom-events";
// import Boost from "highcharts/modules/boost";
// Boost(Highcharts);
HighchartsCustomEvents(Highcharts);
class TopicWiseStackedSentimentBreakupChart extends PureComponent {
    chartComponent = React.createRef();
    state = {};

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getOptions = () => {
        let { positive, negative, neutral, maxpositive, maxnegative, maxneutral } = JSON.parse(JSON.stringify(this.props.data));

        let positiveData = positive;
        let negativeData = negative;
        let neutralData = neutral;

        let self = this;
        const chartConfig = {
            chart: {
                type: "bar",
                //  zoomType: "x",

                //height: 150 * this.props.data.keys.length,
                //backgroundColor: "transparent",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                scrollablePlotArea: {
                    minHeight: this.props.expandWidget ? maxpositive.length * 20 : positive.length,
                },

                events: {
                    load: function () {
                        Highcharts.addEvent(this.tooltip, "headerFormatter", function (e) {
                            if (!e.isFooter) {
                                e.text = `<b>${e.labelConfig.point.labelName}</b><br/>`;
                                return false; // prevent default
                            }
                            return true; // run default
                        });
                    },
                },
            },
            credits: {
                enabled: false,
            },
            // boost: {
            //     // seriesThreshold: 10
            // },

            title: {
                text: " ",
            },
            xAxis: {
                type: "category",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                labels: {
                    formatter: function () {
                        if (this.value != "others") {
                            let label = this.chart.userOptions.series[0].data.find((ele) => ele.name == this.value);

                            return label.labelName.length > 25 ? label.labelName.substring(0, 24) + "..." : label.labelName;
                        } else {
                            return "Others";
                        }
                    },
                    events: {
                        mouseover: function () {
                            const chart = this.chart,
                                tooltip = chart.tooltip,
                                points = chart.series[0].points,
                                thisValue = this.pos;

                            tooltip.refresh(points[thisValue]);
                        },
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                max: 100,
                title: "",
                labels: {
                    format: "{text}%",
                },
            },
            legend: {
                enabled: this.props.showLegend,
                align: "center",
                x: 0,
                y: 0,
            },
            series: [
                {
                    //boostThreshold:50,
                    name: "Positive",
                    data: positiveData,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("positive"),
                    marker: {
                        fillColor: getSentimentColor("positive"),
                        symbol: "square",
                    },
                },
                {
                    // boostThreshold: 5000,
                    name: "Negative",
                    data: negativeData,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("negative"),
                    marker: {
                        fillColor: getSentimentColor("negative"),
                        symbol: "square",
                    },
                },
                {
                    //  boostThreshold: 5000,
                    name: "Neutral",
                    data: neutralData,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("neutral"),
                    marker: {
                        fillColor: getSentimentColor("neutral"),
                        symbol: "square",
                    },
                },
            ],
            plotOptions: {
                series: {
                    borderWidth: 0,
                    minPointLength: 8,
                    stacking: "normal",
                    dataLabels: {
                        enabled: this.props.showLabel,
                        style: {
                            fontWeight: "bold",
                            textOutline: "none",
                        },
                        formatter: function () {
                            return `${this.y} %`;
                        },
                    },
                },
                bar: {
                    borderWidth: 0,
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },

            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: true,
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                useHTML: true,

                pointFormatter: function () {
                    let toolTipData = "";
                    let topicTotal = this.totalData;
                    if (topicTotal != 0 && this.y != 0) {
                        toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:3px 1px;">
                        
                        <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                         <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
                             this.series.color
                         };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">   <b>${
                            this.series.name
                        } </b></span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                            this.y.toFixed(1) + "%"
                        }</b> </span> <span style="display:inline-block;padding:1px"><b>(${this.doc_count} / ${this.totData})</b> </span><br/> </span>`;
                    }
                    return toolTipData;
                },
                // pointFormat: '<span">{series.name}</span>: <b>{point.y}%</b> | <b>{point.doc_count}/{point.totData}</b><br/>',
                style: {
                    fontWeight: "normal",
                },
            },
        };

        return chartConfig;
    };

    getmaximizeOptions = () => {
        let { positive, negative, neutral, maxpositive, maxnegative, maxneutral } = JSON.parse(JSON.stringify(this.props.data));

        let positiveData = maxpositive;
        let negativeData = maxnegative;
        let neutralData = maxneutral;

        let self = this;
        const chartConfig = {
            chart: {
                type: "bar",
                //  zoomType: "x",

                //height: 150 * this.props.data.keys.length,
                // backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                scrollablePlotArea: {
                    minHeight: this.props.expandWidget ? (maxpositive.length < 25 ? maxpositive.length : maxpositive.length * 22) : positive.length,
                    opacity: 1,
                },
                events: {
                    load: function () {
                        Highcharts.addEvent(this.tooltip, "headerFormatter", function (e) {
                            if (!e.isFooter) {
                                e.text = `<b>${e.labelConfig.point.labelName}</b><br/>`;
                                return false; // prevent default
                            }
                            return true; // run default
                        });
                    },
                },
            },
            credits: {
                enabled: false,
            },
            // boost: {
            //     // seriesThreshold: 10
            // },

            title: {
                text: " ",
            },
            xAxis: {
                type: "category",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                labels: {
                    formatter: function () {
                        if (this.value != "others") {
                            let label = this.chart.userOptions.series[0].data.find((ele) => ele.name == this.value);

                            return label.labelName.length > 25 ? label.labelName.substring(0, 24) + "..." : label.labelName;
                        } else {
                            return "Others";
                        }
                    },
                    events: {
                        mouseover: function () {
                            const chart = this.chart,
                                tooltip = chart.tooltip,
                                points = chart.series[0].points,
                                thisValue = this.pos;

                            tooltip.refresh(points[thisValue]);
                        },
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                max: 100,
                title: "",
                labels: {
                    format: "{text}%",
                },
            },
            legend: {
                enabled: this.props.showLegend,
                align: "center",
                x: 0,
                y: 0,
            },
            series: [
                {
                    //boostThreshold:50,
                    name: "Positive",
                    data: positiveData,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("positive"),
                    marker: {
                        fillColor: getSentimentColor("positive"),
                        symbol: "square",
                    },
                },
                {
                    // boostThreshold: 5000,
                    name: "Negative",
                    data: negativeData,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("negative"),
                    marker: {
                        fillColor: getSentimentColor("negative"),
                        symbol: "square",
                    },
                },
                {
                    //  boostThreshold: 5000,
                    name: "Neutral",
                    data: neutralData,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("neutral"),
                    marker: {
                        fillColor: getSentimentColor("neutral"),
                        symbol: "square",
                    },
                },
            ],
            plotOptions: {
                series: {
                    borderWidth: 0,
                    stacking: "normal",
                    dataLabels: {
                        enabled: this.props.showLabel,
                        style: {
                            fontWeight: "bold",
                            textOutline: "none",
                        },
                        formatter: function () {
                            return `${this.y} %`;
                        },
                    },
                },
                bar: {
                    borderWidth: 0,
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },

            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: true,
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                useHTML: true,

                pointFormatter: function () {
                    let toolTipData = "";
                    let topicTotal = this.totalData;

                    if (topicTotal != 0 && this.y != 0) {
                        toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:3px 1px;">
                        <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                         <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
                             this.series.color
                         };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">   <b>${
                            this.series.name
                        } </b></span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                            this.y + "%"
                        }</b> </span> <span style="display:inline-block;padding:1px"><b>(${this.doc_count} / ${this.totData})</b> </span><br/> </span>`;
                    }
                    return toolTipData;
                },
                //pointFormat: '<span">{series.name}</span>: <b>{point.y}%</b> | <b>{point.doc_count}/{point.totData}</b><br/>',
                style: {
                    fontWeight: "normal",
                },
            },
        };

        return chartConfig;
    };

    render() {
        return (
            <>
                {this.props.expandWidget ? (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getmaximizeOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "100%" } }}
                        // oneToOne={true}
                        allowChartUpdate={true}
                    />
                ) : (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "100%" } }}
                        // oneToOne={true}
                        allowChartUpdate={true}
                    />
                )}
            </>
        );
    }
}

export default TopicWiseStackedSentimentBreakupChart;
